// import React from 'react'
// import Form from '../2/Controls/Form';
// import Input from '../2/Controls/Input';
// import Window from '../2/Controls/Window';
// import { getHelpDeskProrites, getProperty } from '../../CommonFunctions';
// import { config } from 'exceljs';
// import Autocompletesearch from '../2/Controls/Autocompletesearch';
// import Icon from '../2/Controls/Icon';
// import FileUploader from '../2/Controls/FileUploader';

// class AddTicket extends React.Component {
//     constructor(props) {
//         super(props)
//         this.state = {
//             config: {},
//             types: [],
//             loading: false,
//             saving: false,
//             selectedCustomer: null,
//             customerSearchValue: '',
//             // For customer typeahead
//             customerTypeAheadOptions: [],
//             isCustomerTypeAheadLoading: false,
//             query: '',
//             selectedType: "",
//             selectedTypeDoc: null, // Added to store full type object
//             subTypeId: "",
//             subType: "",
//             customerProducts: [],
//             customerOrders: [],
//             description: "",
//             attachements: [], // Fixed: changed from 'attachments' to 'attachements' to match FileUploader
//             selectedProducts: [], // Added
//             orderNumber: "", // Added
//             isSubmitting: false,
//             descriptionErrorMessage: "",
//             typeErrorMessage: "",
//             subTypeErrorMessage: "",
//             orderNumberErrorMessage: "",
//             productErrorMessage: "",
//             customerErrorMessage: "",
//         }

//         // Bind methods
//         this.onCustomerSearch = this.onCustomerSearch.bind(this);
//         this.onCustomerSelect = this.onCustomerSelect.bind(this);
//         this.onProductSelected = this.onProductSelected.bind(this);
//         this.onOrderSelected = this.onOrderSelected.bind(this);
//         this.removeSelectedProduct = this.removeSelectedProduct.bind(this);
//     }



//     getHelpDeskConfiguration = async () => {
//         this.setState({ loading: true });

//         try {
//             const registrationId = this.props.user.user.RegistrationID;
//             const result = await this.props.getHelpDeskConfiguration(registrationId);
//             this.setState({ config: result });
//         } catch (error) {
//             console.error("Error loading configuration:", error);
//         } finally {
//             this.setState({ loading: false });
//         }
//     };

//     getHelpDeskTypes = async () => {
//         try {
//             let types = await this.props.getHelpDeskType(this.props.user.user.RegistrationID);
//             this.setState({ types: types });
//         } catch (error) {
//             console.error("Error loading types:", error);
//         }
//     };

//     getCustomerOtherDetail = async (customerID) => {
//         try {
//             this.props.getCustomerProductsFromDenomSales(customerID)
//                 .then((result) => {
//                     this.setState({ customerProducts: result })
//                 });
//             this.props.getCustomerTransactions(customerID, 0, 10000)
//                 .then((result) => {
//                     this.setState({ customerOrders: result.searchResult })
//                 });
//         } catch (error) {
//             console.error(error);
//         }
//     }

//     componentDidMount() {
//         this.setState({ saving: true });
//         this.getHelpDeskConfiguration();
//         this.getHelpDeskTypes();
//         this.setState({ saving: false });
//     }

//     // Search customers with debouncing
//     onCustomerSearch(query) {
//         this.setState({
//             isCustomerTypeAheadLoading: true,
//             query: query
//         });

//         this.props
//             .searchCustomer(
//                 this.props.user.user.RegistrationID,
//                 this.props.user.store.key,
//                 query
//             )
//             .then((result) => {
//                 console.log("Search results:", result.searchResult);
//                 this.setState({
//                     customerTypeAheadOptions: result.searchResult || [],
//                     isCustomerTypeAheadLoading: false
//                 });
//             })
//             .catch((error) => {
//                 console.error("Customer search error:", error);
//                 this.setState({
//                     customerTypeAheadOptions: [],
//                     isCustomerTypeAheadLoading: false
//                 });
//             });
//     }

//     // Handle customer selection
//     onCustomerSelect(customer) {
//         this.setState({
//             selectedCustomer: customer,
//             customerErrorMessage: ""
//         });
//         this.getCustomerOtherDetail(customer.key);
//     }

//     // Handle product selection
//     onProductSelected(product) {
//         if (product && !this.state.selectedProducts.some(p => p.key === product.key)) {
//             this.setState(prevState => ({
//                 selectedProducts: [...prevState.selectedProducts, product],
//                 productErrorMessage: ""
//             }));
//         }
//     }

//     // Remove selected product
//     removeSelectedProduct(productId) {
//         this.setState(prevState => ({
//             selectedProducts: prevState.selectedProducts.filter(p => p.ProductID !== productId)
//         }));
//     }

//     // Handle order selection
//     onOrderSelected(order) {
//         if (order) {
//             this.setState({ orderNumberErrorMessage: "", orderNumber: order.TransactionNo });
//         }
//     }


//     onSave = () => {
//         const { attachements, selectedProducts, orderNumber, description, selectedCustomer, selectedType, selectedTypeDoc, subType, subTypeId } = this.state;
//         const { store, registration } = this.props;

//         let descriptionErrorMessage = "";
//         let typeErrorMessage = "";
//         let subTypeErrorMessage = "";
//         let orderNumberErrorMessage = "";
//         let productErrorMessage = "";
//         let customerErrorMessage = "";

//         const uploadingAttachments = attachements.filter(att => att.uploading);
//         if (uploadingAttachments.length > 0) {
//             alert(`Please wait, ${uploadingAttachments.length} file(s) are still uploading`);
//             return;
//         }

//         const failedAttachments = attachements.filter(att => att.error);
//         if (failedAttachments.length > 0) {
//             alert(`Some files failed to upload. Please remove them and try again.`);
//             return;
//         }
//         if (!selectedCustomer || !selectedCustomer.hasOwnProperty("key")) {
//             customerErrorMessage = 'Please select customer';
//         }
//     if (getProperty(this.state.config, 'IsTypeMandatory') && !selectedType) {
//     typeErrorMessage = `Please select a ticket ${getProperty(this.state.config, 'TypeLabel')}`;
// }
// if (getProperty(this.state.config, 'IsSubTypeMandatory') && !subTypeId) {
//     subTypeErrorMessage = `Please select a ticket ${getProperty(this.state.config, 'SubTypeLabel')}`;
// }
//         if (!description) {
//             descriptionErrorMessage = 'Please provide a description';
//         }

//         if (getProperty(getProperty(selectedTypeDoc, 'Settings'), 'IsRequireProduct') && selectedProducts.length === 0) {
//             productErrorMessage = 'At least one product is required for this ticket type';
//         }

//         if (getProperty(getProperty(selectedTypeDoc, 'Settings'), 'IsRequireOrder') && !orderNumber) {
//             orderNumberErrorMessage = 'Order number is required for this ticket type';
//         }


//         if (typeErrorMessage !== "" || subTypeErrorMessage !== "" || productErrorMessage !== "" || orderNumberErrorMessage !== "" || customerErrorMessage !== "" || descriptionErrorMessage !== "") {
//             this.setState({
//                 typeErrorMessage: typeErrorMessage,
//                 subTypeErrorMessage: subTypeErrorMessage,
//                 productErrorMessage: productErrorMessage,
//                 customerErrorMessage: customerErrorMessage,
//                 orderNumberErrorMessage: orderNumberErrorMessage,
//                 descriptionErrorMessage: descriptionErrorMessage
//             })
//             return;
//         }
//         this.setState({ isSubmitting: true });

//         try {
//             const selectedOrder = this.state.customerOrders.find(order => order.TransactionNo === orderNumber);

//             const productsArray = selectedProducts.map(product => ({
//                 ProductName: product.ProductName || "",
//                 SKU: product.SKU || "",
//                 Barcode: product.BarCode || "",
//                 ProductId: product.ProductID ||"",
//                 ProductType: product.ProductType || "",
//                 UniqueNo1: product.UniqueNo1 || "",
//                 UniqueNo2: product.UniqueNo2 || "",
//                 UniqueNo3: product.UniqueNo3 || "",
//                 UniqueNo4: product.UniqueNo4 || "",
//                 ProductCustomField1: product.ProductCustomField1 || "",
//                 ProductCustomField2: product.ProductCustomField2 || "",
//                 ProductCustomField3: product.ProductCustomField3 || "",
//                 ProductCustomField4: product.ProductCustomField4 || "",
//                 ProductCustomField5: product.ProductCustomField5 || "",
//                 ProductCustomField6: product.ProductCustomField6 || "",
//             }));

//             const orderObject = selectedOrder ? {
//                 TransactionNo: selectedOrder.TransactionNo || "",
//                 TransactionId: selectedOrder.key || "",
//             } : {};

//             const ticketNumber = `TKT-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;

//             const attachmentObjects = attachements
//                 .filter(att => att.url && !att.uploading && !att.error)
//                 .map(att => ({
//                     Url: att.url,
//                     FileType: att.type || att.FileType || 'application/octet-stream',
//                     FileName: att.name || att.FileName || 'file'
//                 }));

//             const ticketData = {
//                 StoreID: selectedCustomer.StoreID,
//                 TicketNumber: ticketNumber,
//                 RegistrationID: this.props.user.user.RegistrationID,
//                 Customer: selectedCustomer,
//                 Products: productsArray,
//                 Type: getProperty(selectedTypeDoc, 'Type') || "",
//                 TypeId: selectedType || "",
//                 SubType: subType || "",
//                 SubTypeId: subTypeId || "",
//                 Status: "New",
//                 Order: orderObject,
//                 Source: "omni web",
//                 Priority: getProperty(getProperty(selectedTypeDoc, 'Settings'), 'DefaultPriority'),
//                 TimeLine: [
//                     {
//                         Action: "New",
//                         ActionOn: new Date(),
//                         TicketStatus: "New",
//                         Message: {
//                             Content: description || "",
//                             IsRead: false,
//                             IsDeleiverd: false,
//                             ActionBy: "user",
//                             Attachments: attachmentObjects
//                         },
//                         Remark: "",
//                         AssignTo: {},
//                         ActionByEmailId: getProperty(selectedCustomer, 'EmailID'),
//                         ActionByUserId: getProperty(selectedCustomer, 'key'),
//                     }
//                 ]
//             };

//             this.props.saveTicket(ticketData)
//                 .then(response => {
//                     if (response.code === "0") {
//                         alert("Ticket created successfully!");
//                         this.props.onSave();
//                     } else {
//                         alert(getProperty(response, 'message') || "Failed to submit ticket");
//                     }
//                 })
//                 .catch(err => {
//                     alert('Failed to submit ticket. Please try again.');
//                     console.error("345", err);
//                 })
//                 .finally(() => {
//                     this.setState({ isSubmitting: false });
//                 });

//         } catch (err) {
//             alert('Failed to submit ticket. Please try again.');
//             console.error("345", err);
//             this.setState({ isSubmitting: false });
//         }
//     };

//     render() {
//         const {
//             customerTypeAheadOptions,
//             isCustomerTypeAheadLoading,
//             selectedCustomer,
//             customerSearchValue,
//             selectedType,
//             types,
//             config,
//             customerProducts,
//             customerOrders,
//             attachements,
//             selectedProducts,
//             orderNumber,
//             description,
//             isSubmitting
//         } = this.state;

//         const styles = {

//             productSection: {
//                 marginTop: '16px'
//             },
//             productList: {
//                 marginTop: '8px'
//             },
//             productItem: {
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 backgroundColor: '#EBF5FF',
//                 border: '1px solid #BFDBFE',
//                 borderRadius: '8px',
//                 padding: '12px',
//                 marginBottom: '8px'
//             },
//             productInfo: {
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '12px',
//                 flex: 1,
//                 minWidth: 0
//             },
//             productDetails: {
//                 flex: 1,
//                 minWidth: 0
//             },
//             productName: {
//                 fontWeight: '500',
//                 color: '#111827',
//                 margin: 0,
//                 overflow: 'hidden',
//                 textOverflow: 'ellipsis',
//                 whiteSpace: 'nowrap'
//             },
//             productSku: {
//                 fontSize: '14px',
//                 color: '#4B5563',
//                 margin: 0
//             },
//             removeButton: {
//                 marginLeft: '8px',
//                 padding: '4px',
//                 color: '#EF4444',
//                 background: 'none',
//                 border: 'none',
//                 cursor: 'pointer',
//                 borderRadius: '8px',
//                 transition: 'background-color 0.2s'
//             },
//             removeButtonHover: {
//                 backgroundColor: '#FEF2F2'
//             },
//             label: {
//                 display: 'block',
//                 fontSize: '14px',
//                 fontWeight: '600',
//                 color: '#374151',
//                 marginBottom: '8px'
//             },
//             selectedProductsLabel: {
//                 display: 'block',
//                 fontSize: '14px',
//                 fontWeight: '600',
//                 color: '#374151',
//                 marginBottom: '8px'
//             },
//             suggestionContainer: {
//                 display: 'flex',
//                 gap: '10px',
//                 alignItems: 'flex-start',
//                 width: '100%',
//                 minWidth: 0,
//                 paddingRight: '16px'
//             },

//             formContainer: {
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: '10px',
//             },
//         };

//         return (
//             <Window
//                 header={"New Ticket"}
//                 onButtonClick={(action) => {
//                     if (action.toLowerCase() === "save") {
//                         this.onSave();
//                     } else {
//                         this.props.onClose();
//                     }
//                 }}
//                 buttons={[
//                     { Type: "secondary", Text: "Cancel", Align: "left" },
//                     { Type: "primary", Text: "Save", Align: "right" },
//                 ]}
//                 processing={isSubmitting}
//                 onClose={() => this.props.onClose()}
//                 slide={true}
//             >
//                 <div style={styles.formContainer}>
//                     <Autocompletesearch
//                         label="Customer"
//                         placeholder="Search customer by name, email or phone"
//                         value={customerSearchValue}
//                         data={customerTypeAheadOptions}
//                         filterKey={['FirstName', 'LastName', 'PhoneNo', 'EmailID']}
//                         defaultDataCount={5}
//                         onChange={this.onCustomerSearch}
//                         onSelect={this.onCustomerSelect}
//                         isMandatory={true}
//                         showSideLoader={isCustomerTypeAheadLoading}
//                         renderSuggestion={(item) => (
//                             <div style={styles.suggestionContainer}>
//                                 <div >
//                                     <div>
//                                         <p >
//                                             {item.FirstName} {item.LastName}
//                                         </p>
//                                     </div>
//                                     {item.PhoneNo && (
//                                         <p style={{ margin: 0 }}>{item.PhoneNo}</p>
//                                     )}
//                                     {item.EmailID && (
//                                         <p style={{ margin: 0 }}>{item.EmailID}</p>
//                                     )}
//                                 </div>
//                             </div>
//                         )}
//                         errorMessage={this.state.customerErrorMessage}
//                     />

//                     {getProperty(config, 'IsShowType') &&

//                         <Input
//                             type="select"
//                             label={getProperty(config, "TypeLabel")}
//                             value={selectedType}
//                             isMandatory={getProperty(config, "IsTypeMandatory")}
//                             onChange={(v) => {
//                                 let type = types.filter((f) => f.key === v)[0];
//                                 this.setState({
//                                     selectedType: v,
//                                     selectedTypeDoc: type,
//                                     typeErrorMessage: "",
//                                     subTypeId:"",
//                                     subType:""
//                                 });
//                             }}
//                             error={this.state.typeErrorMessage}
//                         >
//                             <option key={""} value={""}>
//                                 Select Any
//                             </option>
//                             {types.map(option => (
//                                 <option key={option.key} value={option.key}>
//                                     {option.Type}
//                                 </option>
//                             ))}
//                         </Input>
//                     }

//                     {(selectedType &&
//                         (getProperty(this.state.selectedTypeDoc, 'SubTypes') &&
//                             getProperty(this.state.selectedTypeDoc, 'SubTypes').length > 0)) &&

//                         <Input
//                             type="select"
//                             label={getProperty(config, "SubTypeLabel")}
//                             value={this.state.subTypeId}
//                             isMandatory={getProperty(config, "IsSubTypeMandatory")}
//                             onChange={(v) => {
//                                 let type = types.find(t => t.key === selectedType);
//                                 let subTypeObj = getProperty(type, 'SubTypes') &&
//                                     getProperty(type, 'SubTypes').filter((f) => f._id === v)[0];
//                                 this.setState({
//                                     subTypeErrorMessage: "",
//                                     subTypeId: v,
//                                     subType: getProperty(subTypeObj, 'Name') || ""
//                                 });
//                             }}
//                             error={this.state.subTypeErrorMessage}
//                         >
//                              <option key={""} value={""}>
//                                 Select Any
//                             </option>
//                             {this.state.selectedTypeDoc && this.state.selectedTypeDoc.SubTypes &&
//                                 this.state.selectedTypeDoc.SubTypes.map(option => (
//                                     <option key={option._id} value={option._id}>
//                                         {option.Name}
//                                     </option>
//                                 ))
//                             }
//                         </Input>

//                     }

//                     {(getProperty(getProperty(this.state.selectedTypeDoc, 'Settings'), 'IsRequireProduct')) && (
//                         <div >
//                             <Autocompletesearch
//                                 label={"Select Products"}
//                                 clearInputValueAfterSelect={true}
//                                 data={customerProducts}
//                                 filterKey={["ProductName", "SKU", "BarCode"]}
//                                 defaultDataCount={1000}
//                                 onChange={(value) => { }}
//                                 onSelect={this.onProductSelected}
//                                 placeholder="Search product by name, SKU, barcode..."
//                                 value={null}
//                                 errorMessage={this.state.productErrorMessage}
//                                 renderSuggestion={(item, index) => (
//                                     <div style={styles.suggestionContainer}>
//                                         <div >
//                                             <div >
//                                                 <span >
//                                                     {item.ProductName}
//                                                 </span>
//                                             </div>
//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '100%', minWidth: 0, paddingRight: '8px' }}>
//                                                 {item.SKU && (
//                                                     <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '14px' }} title={item.SKU}>
//                                                         SKU: {item.SKU}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             />

//                             {selectedProducts.length > 0 && (
//                                 <div style={styles.productSection}>
//                                     <label style={styles.selectedProductsLabel}>
//                                         Selected Products ({selectedProducts.length})
//                                     </label>
//                                     <div style={styles.productList}>
//                                         {selectedProducts.map((product) => (
//                                             <div key={product.key} style={styles.productItem}>
//                                                 <div style={styles.productInfo}>
//                                                     <div style={styles.productDetails}>
//                                                         <p style={styles.productName}>{product.ProductName}</p>
//                                                         {product.SKU && (
//                                                             <p style={styles.productSku}>SKU: {product.SKU}</p>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                                 <button
//                                                     type="button"
//                                                     onClick={() => this.removeSelectedProduct(product.key)}
//                                                     style={styles.removeButton}
//                                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FEF2F2'}
//                                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
//                                                     title="Remove product"
//                                                 >
//                                                     <Icon type="remove" />
//                                                 </button>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     )}

//                     {(getProperty(getProperty(this.state.selectedTypeDoc, 'Settings'), 'IsRequireOrder')) && (
//                         <div >
//                             <Autocompletesearch
//                                 label={"Search or select order"}
//                                 clearInputValueAfterSelect={false}
//                                 data={customerOrders}
//                                 filterKey={["TransactionNo"]}
//                                 defaultDataCount={1000}
//                                 onChange={(value) => { }}
//                                 onSelect={this.onOrderSelected}
//                                 placeholder="Search order by no..."
//                                 value={orderNumber}
//                                 errorMessage={this.state.orderNumberErrorMessage}
//                                 renderSuggestion={(item, index) => (
//                                     <div style={styles.suggestionContainer}>
//                                         <div >
//                                             <div >
//                                                 <span >
//                                                     {item.TransactionNo}
//                                                 </span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             />
//                         </div>
//                     )}


//                     <Input
//                         type="textarea"
//                         label="Description"
//                         onChange={(value) => this.setState({ descriptionErrorMessage: "", description: value })}
//                         value={description}
//                         isMandatory={true}
//                         error={this.state.descriptionErrorMessage}

//                     />

//                     <FileUploader
//                         {...this.props}
//                         maxFiles={5}
//                         maxSizeKB={1024}
//                         files={attachements}
//                         storageFolder="ticket-attachments"
//                         supportFile={["pdf", "image"]}
//                         onUploadSuccess={(files) => {
//                             this.setState({ attachements: files });
//                         }}
//                         onFileDelete={(updatedFiles) => {
//                             this.setState({ attachements: updatedFiles });
//                         }}
//                     />
//                 </div>
//             </Window>
//         );
//     }
// }

// export default AddTicket;

import React from 'react'
import Form from '../2/Controls/Form';
import Input from '../2/Controls/Input';
import Window from '../2/Controls/Window';
import { getHelpDeskProrites, getProperty } from '../../CommonFunctions';
import { config } from 'exceljs';
import Autocompletesearch from '../2/Controls/Autocompletesearch';
import Icon from '../2/Controls/Icon';
import FileUploader from '../2/Controls/FileUploader';

class AddTicket extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            config: {},
            types: [],
            loading: false,
            saving: false,
            selectedCustomer: null,
            customerSearchValue: '',
            // For customer typeahead
            customerTypeAheadOptions: [],
            isCustomerTypeAheadLoading: false,
            query: '',
            selectedType: "",
            selectedTypeDoc: null, // Added to store full type object
            subTypeId: "",
            subType: "",
            customerProducts: [],
            customerOrders: [],
            description: "",
            attachements: [], // Fixed: changed from 'attachments' to 'attachements' to match FileUploader
            selectedProducts: [], // Added
            orderNumber: "", // Added
            isSubmitting: false,
            descriptionErrorMessage: "",
            typeErrorMessage: "",
            subTypeErrorMessage: "",
            orderNumberErrorMessage: "",
            productErrorMessage: "",
            customerErrorMessage: "",
            uniqueNoList: [],
            showUniqueNoModal: false,
            selectedUniqueNo: [],
            pendingProduct: null, // Track product being processed
            selectedUniqueNosForTicket: [], // Store selected unique numbers
            modalSelectedUniqueNos: [] // For modal selection state
        }

        // Bind methods
        this.onCustomerSearch = this.onCustomerSearch.bind(this);
        this.onCustomerSelect = this.onCustomerSelect.bind(this);
        this.onProductSelected = this.onProductSelected.bind(this);
        this.onOrderSelected = this.onOrderSelected.bind(this);
        this.removeSelectedProduct = this.removeSelectedProduct.bind(this);
    }



    getHelpDeskConfiguration = async () => {
        this.setState({ loading: true });

        try {
            const registrationId = this.props.user.user.RegistrationID;
            const result = await this.props.getHelpDeskConfiguration(registrationId);
            this.setState({ config: result });
        } catch (error) {
            console.error("Error loading configuration:", error);
        } finally {
            this.setState({ loading: false });
        }
    };

    getHelpDeskTypes = async () => {
        try {
            let types = await this.props.getHelpDeskType(this.props.user.user.RegistrationID);
            this.setState({ types: types });
        } catch (error) {
            console.error("Error loading types:", error);
        }
    };

    getCustomerOtherDetail = async (customerID) => {
        try {
            this.props.getCustomerProductsFromDenomSales(customerID)
                .then((result) => {
                    this.setState({ customerProducts: result })
                });
            this.props.getCustomerTransactions(customerID, 0, 10000)
                .then((result) => {
                    this.setState({ customerOrders: result.searchResult })
                });
        } catch (error) {
            console.error(error);
        }
    }

    componentDidMount() {
        this.setState({ saving: true });
        this.getHelpDeskConfiguration();
        this.getHelpDeskTypes();
        this.setState({ saving: false });
    }

    // Search customers with debouncing
    onCustomerSearch(query) {
        this.setState({
            isCustomerTypeAheadLoading: true,
            query: query
        });

        this.props
            .searchCustomer(
                this.props.user.user.RegistrationID,
                this.props.user.store.key,
                query
            )
            .then((result) => {
                console.log("Search results:", result.searchResult);
                this.setState({
                    customerTypeAheadOptions: result.searchResult || [],
                    isCustomerTypeAheadLoading: false
                });
            })
            .catch((error) => {
                console.error("Customer search error:", error);
                this.setState({
                    customerTypeAheadOptions: [],
                    isCustomerTypeAheadLoading: false
                });
            });
    }

    // Handle customer selection
    onCustomerSelect(customer) {
        this.setState({
            selectedCustomer: customer,
            customerErrorMessage: ""
        });
        this.getCustomerOtherDetail(customer.key);
    }

    // Handle product selection
onProductSelected = async (product) => {
    console.log("product",product);
    if (product && !this.state.selectedProducts.some(p => p.key === product.key)) {
        if (product.InventoryType === "Unique No") {
            try {
                const uniqueNos = await this.props.getUniqueNosByCustomerIdProductId(
                    0,
                    1000,
                    this.state.selectedCustomer.key,
                    product.key
                );

                if (uniqueNos && uniqueNos.length > 0) {
                    const uniqueNoListWithProduct = uniqueNos.map(item => ({
                        ...item,
                        ProductId: product.key,
                        ProductName: product.Name,
                        UniqueNo: item.UniqueNo || item.uniqueNo
                    }));

                    this.setState({
                        uniqueNoList: uniqueNoListWithProduct,
                        showUniqueNoModal: true,
                        pendingProduct: product,
                        modalSelectedUniqueNos: []
                    });
                } else {
                    this.setState(prevState => ({
                        selectedProducts: [...prevState.selectedProducts, product],
                        productErrorMessage: ""
                    }));
                }
            } catch (error) {
                console.error("Error fetching unique numbers:", error);
                alert("Failed to fetch unique numbers for this product");
            }
        } else {
            this.setState(prevState => ({
                selectedProducts: [...prevState.selectedProducts, product],
                productErrorMessage: ""
            }));
        }
    }
};

// Toggle unique number selection in modal
toggleUniqueNoSelection = (uniqueNo) => {
    this.setState(prevState => {
        const isSelected = prevState.modalSelectedUniqueNos.some(
            item => item.key === uniqueNo.key
        );

        if (isSelected) {
            return {
                modalSelectedUniqueNos: prevState.modalSelectedUniqueNos.filter(
                    item => item.key !== uniqueNo.key
                )
            };
        } else {
            return {
                modalSelectedUniqueNos: [...prevState.modalSelectedUniqueNos, uniqueNo]
            };
        }
    });
};



// Handle clear all in modal
handleClearAllUniqueNos = () => {
    this.setState({ modalSelectedUniqueNos: [] });
};

// Handle unique no selection save
handleUniqueNoSelectionSave = () => {
    const { modalSelectedUniqueNos, pendingProduct } = this.state;

    if (modalSelectedUniqueNos && modalSelectedUniqueNos.length > 0) {
        this.setState(prevState => ({
            selectedProducts: [...prevState.selectedProducts, pendingProduct],
            selectedUniqueNosForTicket: [...prevState.selectedUniqueNosForTicket, ...modalSelectedUniqueNos],
            showUniqueNoModal: false,
            pendingProduct: null,
            modalSelectedUniqueNos: [],
            productErrorMessage: ""
        }));
    } else {
        alert("Please select at least one unique number for this product");
    }
};

// Handle modal close without selection
handleUniqueNoModalClose = () => {
    this.setState({
        showUniqueNoModal: false,
        pendingProduct: null,
        modalSelectedUniqueNos: []
    });
};

    // Remove selected product
    removeSelectedProduct(productId) {
        this.setState(prevState => ({
            selectedProducts: prevState.selectedProducts.filter(p => p.ProductID !== productId)
        }));
    }

    // Handle order selection
    onOrderSelected(order) {
        if (order) {
            this.setState({ orderNumberErrorMessage: "", orderNumber: order.TransactionNo });
        }
    }


    onSave = () => {
        const { attachements, selectedProducts, orderNumber, description, selectedCustomer, selectedType, selectedTypeDoc, subType, subTypeId } = this.state;
        const { store, registration } = this.props;

        let descriptionErrorMessage = "";
        let typeErrorMessage = "";
        let subTypeErrorMessage = "";
        let orderNumberErrorMessage = "";
        let productErrorMessage = "";
        let customerErrorMessage = "";

        const uploadingAttachments = attachements.filter(att => att.uploading);
        if (uploadingAttachments.length > 0) {
            alert(`Please wait, ${uploadingAttachments.length} file(s) are still uploading`);
            return;
        }

        const failedAttachments = attachements.filter(att => att.error);
        if (failedAttachments.length > 0) {
            alert(`Some files failed to upload. Please remove them and try again.`);
            return;
        }
        if (!selectedCustomer || !selectedCustomer.hasOwnProperty("key")) {
            customerErrorMessage = 'Please select customer';
        }
        if (getProperty(this.state.config, 'IsTypeMandatory') && !selectedType) {
            typeErrorMessage = `Please select a ticket ${getProperty(this.state.config, 'TypeLabel')}`;
        }
        if (getProperty(this.state.config, 'IsSubTypeMandatory') && !subTypeId) {
            subTypeErrorMessage = `Please select a ticket ${getProperty(this.state.config, 'SubTypeLabel')}`;
        }
        if (!description) {
            descriptionErrorMessage = 'Please provide a description';
        }

        if (getProperty(getProperty(selectedTypeDoc, 'Settings'), 'IsRequireProduct') && selectedProducts.length === 0) {
            productErrorMessage = 'At least one product is required for this ticket type';
        }

        if (getProperty(getProperty(selectedTypeDoc, 'Settings'), 'IsRequireOrder') && !orderNumber) {
            orderNumberErrorMessage = 'Order number is required for this ticket type';
        }


        if (typeErrorMessage !== "" || subTypeErrorMessage !== "" || productErrorMessage !== "" || orderNumberErrorMessage !== "" || customerErrorMessage !== "" || descriptionErrorMessage !== "") {
            this.setState({
                typeErrorMessage: typeErrorMessage,
                subTypeErrorMessage: subTypeErrorMessage,
                productErrorMessage: productErrorMessage,
                customerErrorMessage: customerErrorMessage,
                orderNumberErrorMessage: orderNumberErrorMessage,
                descriptionErrorMessage: descriptionErrorMessage
            })
            return;
        }
        this.setState({ isSubmitting: true });

        try {
            const selectedOrder = this.state.customerOrders.find(order => order.TransactionNo === orderNumber);

            const productsArray = selectedProducts.map(product => ({
                ProductName: product.Name || "",
                SKU: product.SKU || "",
                Barcode: product.BarCode || "",
                ProductId: product.key || "",
                ProductType: product.ProductType || "",
                ProductTypeID: product.ProductTypeID || "",
            }));

            const orderObject = selectedOrder ? {
                TransactionNo: selectedOrder.TransactionNo || "",
                TransactionId: selectedOrder.key || "",
            } : {};

            const ticketNumber = `TKT-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;

            const attachmentObjects = attachements
                .filter(att => att.url && !att.uploading && !att.error)
                .map(att => ({
                    Url: att.url,
                    FileType: att.type || att.FileType || 'application/octet-stream',
                    FileName: att.name || att.FileName || 'file'
                }));

            const ticketData = {
                StoreID: selectedCustomer.StoreID,
                TicketNumber: ticketNumber,
                RegistrationID: this.props.user.user.RegistrationID,
                Customer: selectedCustomer,
                Products: productsArray,
                Type: getProperty(selectedTypeDoc, 'Type') || "",
                TypeId: selectedType || "",
                SubType: subType || "",
                SubTypeId: subTypeId || "",
                Status: "New",
                Order: orderObject,
                Source: "omni web",
                UniqueNo:this.state.selectedUniqueNosForTicket,
                Priority: getProperty(getProperty(selectedTypeDoc, 'Settings'), 'DefaultPriority'),
                TimeLine: [
                    {
                        Action: "New",
                        ActionOn: new Date(),
                        TicketStatus: "New",
                        Message: {
                            Content: description || "",
                            IsRead: false,
                            IsDeleiverd: false,
                            ActionBy: "user",
                            Attachments: attachmentObjects
                        },
                        Remark: "",
                        AssignTo: {},
                        ActionByEmailId: getProperty(selectedCustomer, 'EmailID'),
                        ActionByUserId: getProperty(selectedCustomer, 'key'),
                    }
                ]
            };

            this.props.saveTicket(ticketData)
                .then(response => {
                    if (response.code === "0") {
                        alert("Ticket created successfully!");
                        this.props.onSave();
                    } else {
                        alert(getProperty(response, 'message') || "Failed to submit ticket");
                    }
                })
                .catch(err => {
                    alert('Failed to submit ticket. Please try again.');
                    console.error("345", err);
                })
                .finally(() => {
                    this.setState({ isSubmitting: false });
                });

        } catch (err) {
            alert('Failed to submit ticket. Please try again.');
            console.error("345", err);
            this.setState({ isSubmitting: false });
        }
    };

    render() {
        const {
            customerTypeAheadOptions,
            isCustomerTypeAheadLoading,
            selectedCustomer,
            customerSearchValue,
            selectedType,
            types,
            config,
            customerProducts,
            customerOrders,
            attachements,
            selectedProducts,
            orderNumber,
            description,
            isSubmitting,
             showUniqueNoModal,
    uniqueNoList,
    modalSelectedUniqueNos
        } = this.state;

        const styles = {

            productSection: {
                marginTop: '16px'
            },
            productList: {
                marginTop: '8px'
            },
            productItem: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#EBF5FF',
                border: '1px solid #BFDBFE',
                borderRadius: '8px',
                padding: '12px',
                marginBottom: '8px'
            },
            productInfo: {
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                flex: 1,
                minWidth: 0
            },
            productDetails: {
                flex: 1,
                minWidth: 0
            },
            productName: {
                fontWeight: '500',
                color: '#111827',
                margin: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            productSku: {
                fontSize: '14px',
                color: '#4B5563',
                margin: 0
            },
            removeButton: {
                marginLeft: '8px',
                padding: '4px',
                color: '#EF4444',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '8px',
                transition: 'background-color 0.2s'
            },
            removeButtonHover: {
                backgroundColor: '#FEF2F2'
            },
            label: {
                display: 'block',
                fontSize: '14px',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '8px'
            },
            selectedProductsLabel: {
                display: 'block',
                fontSize: '14px',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '8px'
            },
            suggestionContainer: {
                display: 'flex',
                gap: '10px',
                alignItems: 'flex-start',
                width: '100%',
                minWidth: 0,
                paddingRight: '16px'
            },

            formContainer: {
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
            },
        };

        return (
            <>
            <Window
                header={"New Ticket"}
                onButtonClick={(action) => {
                    if (action.toLowerCase() === "save") {
                        this.onSave();
                    } else {
                        this.props.onClose();
                    }
                }}
                buttons={[
                    { Type: "secondary", Text: "Cancel", Align: "left" },
                    { Type: "primary", Text: "Save", Align: "right" },
                ]}
                processing={isSubmitting}
                onClose={() => this.props.onClose()}
                slide={true}
            >
                <div style={styles.formContainer}>
                    <Autocompletesearch
                        label="Customer"
                        placeholder="Search customer by name, email or phone"
                        value={customerSearchValue}
                        data={customerTypeAheadOptions}
                        filterKey={['FirstName', 'LastName', 'PhoneNo', 'EmailID']}
                        defaultDataCount={5}
                        onChange={this.onCustomerSearch}
                        onSelect={this.onCustomerSelect}
                        isMandatory={true}
                        showSideLoader={isCustomerTypeAheadLoading}
                        renderSuggestion={(item) => (
                            <div style={styles.suggestionContainer}>
                                <div >
                                    <div>
                                        <p >
                                            {item.FirstName} {item.LastName}
                                        </p>
                                    </div>
                                    {item.PhoneNo && (
                                        <p style={{ margin: 0 }}>{item.PhoneNo}</p>
                                    )}
                                    {item.EmailID && (
                                        <p style={{ margin: 0 }}>{item.EmailID}</p>
                                    )}
                                </div>
                            </div>
                        )}
                        errorMessage={this.state.customerErrorMessage}
                    />

                    {getProperty(config, 'IsShowType') &&

                        <Input
                            type="select"
                            label={getProperty(config, "TypeLabel")}
                            value={selectedType}
                            isMandatory={getProperty(config, "IsTypeMandatory")}
                            onChange={(v) => {
                                let type = types.filter((f) => f.key === v)[0];
                                this.setState({
                                    selectedType: v,
                                    selectedTypeDoc: type,
                                    typeErrorMessage: "",
                                    subTypeId: "",
                                    subType: ""
                                });
                            }}
                            error={this.state.typeErrorMessage}
                        >
                            <option key={""} value={""}>
                                Select Any
                            </option>
                            {types.map(option => (
                                <option key={option.key} value={option.key}>
                                    {option.Type}
                                </option>
                            ))}
                        </Input>
                    }

                    {(selectedType &&
                        (getProperty(this.state.selectedTypeDoc, 'SubTypes') &&
                            getProperty(this.state.selectedTypeDoc, 'SubTypes').length > 0)) &&

                        <Input
                            type="select"
                            label={getProperty(config, "SubTypeLabel")}
                            value={this.state.subTypeId}
                            isMandatory={getProperty(config, "IsSubTypeMandatory")}
                            onChange={(v) => {
                                let type = types.find(t => t.key === selectedType);
                                let subTypeObj = getProperty(type, 'SubTypes') &&
                                    getProperty(type, 'SubTypes').filter((f) => f._id === v)[0];
                                this.setState({
                                    subTypeErrorMessage: "",
                                    subTypeId: v,
                                    subType: getProperty(subTypeObj, 'Name') || ""
                                });
                            }}
                            error={this.state.subTypeErrorMessage}
                        >
                            <option key={""} value={""}>
                                Select Any
                            </option>
                            {this.state.selectedTypeDoc && this.state.selectedTypeDoc.SubTypes &&
                                this.state.selectedTypeDoc.SubTypes.map(option => (
                                    <option key={option._id} value={option._id}>
                                        {option.Name}
                                    </option>
                                ))
                            }
                        </Input>

                    }

                    {(getProperty(getProperty(this.state.selectedTypeDoc, 'Settings'), 'IsRequireProduct')) && (
                        <div >
                            <Autocompletesearch
                                label={"Select Products"}
                                clearInputValueAfterSelect={true}
                                data={customerProducts}
                                filterKey={["Name", "SKU", "BarCode"]}
                                defaultDataCount={1000}
                                onChange={(value) => { }}
                                onSelect={this.onProductSelected}
                                placeholder="Search product by name, SKU, barcode..."
                                value={null}
                                errorMessage={this.state.productErrorMessage}
                                renderSuggestion={(item, index) => (
                                    <div style={styles.suggestionContainer}>
                                        <div >
                                            <div >
                                                <span >
                                                    {item.Name}
                                                </span>
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '100%', minWidth: 0, paddingRight: '8px' }}>
                                                {item.SKU && (
                                                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '14px' }} title={item.SKU}>
                                                        SKU: {item.SKU}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            />

                            {selectedProducts.length > 0 && (
                                <div style={styles.productSection}>
                                    <label style={styles.selectedProductsLabel}>
                                        Selected Products ({selectedProducts.length})
                                    </label>
                                    <div style={styles.productList}>
                                        {selectedProducts.map((product) => (
                                            <div key={product.key} style={styles.productItem}>
                                                <div style={styles.productInfo}>
                                                    <div style={styles.productDetails}>
                                                        <p style={styles.productName}>{product.Name}</p>
                                                        {product.SKU && (
                                                            <p style={styles.productSku}>SKU: {product.SKU}</p>
                                                        )}
                                                    </div>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => this.removeSelectedProduct(product.key)}
                                                    style={styles.removeButton}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FEF2F2'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                    title="Remove product"
                                                >
                                                    <Icon type="remove" />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {(getProperty(getProperty(this.state.selectedTypeDoc, 'Settings'), 'IsRequireOrder')) && (
                        <div >
                            <Autocompletesearch
                                label={"Search or select order"}
                                clearInputValueAfterSelect={false}
                                data={customerOrders}
                                filterKey={["TransactionNo"]}
                                defaultDataCount={1000}
                                onChange={(value) => { }}
                                onSelect={this.onOrderSelected}
                                placeholder="Search order by no..."
                                value={orderNumber}
                                errorMessage={this.state.orderNumberErrorMessage}
                                renderSuggestion={(item, index) => (
                                    <div style={styles.suggestionContainer}>
                                        <div >
                                            <div >
                                                <span >
                                                    {item.TransactionNo}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            />
                        </div>
                    )}


                    <Input
                        type="textarea"
                        label="Description"
                        onChange={(value) => this.setState({ descriptionErrorMessage: "", description: value })}
                        value={description}
                        isMandatory={true}
                        error={this.state.descriptionErrorMessage}

                    />

                    <FileUploader
                        {...this.props}
                        maxFiles={5}
                        maxSizeKB={1024}
                        files={attachements}
                        storageFolder="ticket-attachments"
                        supportFile={["pdf", "image"]}
                        onUploadSuccess={(files) => {
                            this.setState({ attachements: files });
                        }}
                        onFileDelete={(updatedFiles) => {
                            this.setState({ attachements: updatedFiles });
                        }}
                    />
                </div>
            </Window>

            {/* Unique Number Selection Modal */}
{this.state.showUniqueNoModal && (
    <Window
        header={`Select Unique Numbers (${this.state.uniqueNoList.length} available)`}
        onButtonClick={(action) => {
            if (action.toLowerCase() === "save") {
                this.handleUniqueNoSelectionSave();
            } else {
                this.handleUniqueNoModalClose();
            }
        }}
        buttons={[
            { Type: "secondary", Text: "Cancel", Align: "left" },
            { Type: "primary", Text: "Save", Align: "right" }
        ]}
        onClose={this.handleUniqueNoModalClose}
        slide={true}
        width="600px"
    >
        <div style={{ padding: '20px' }}>
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '20px' 
            }}>
                <span style={{ fontSize: '14px', color: '#6B7280' }}>
                    Selected: {this.state.modalSelectedUniqueNos.length} of {this.state.uniqueNoList.length}
                </span>
                <div style={{ display: 'flex', gap: '10px' }}>
                    {/* <button 
                        style={{
                            padding: '6px 12px',
                            border: '1px solid #D1D5DB',
                            borderRadius: '6px',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#374151'
                        }}
                        onClick={this.handleSelectAllUniqueNos}
                    >
                        Select All
                    </button> */}
                    {/* <button 
                        style={{
                            padding: '6px 12px',
                            border: '1px solid #D1D5DB',
                            borderRadius: '6px',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#374151'
                        }}
                        onClick={this.handleClearAllUniqueNos}
                    >
                        Clear All
                    </button> */}
                </div>
            </div>

            <div style={{
                maxHeight: '400px',
                overflowY: 'auto',
                border: '1px solid #E5E7EB',
                borderRadius: '8px'
            }}>
                {this.state.uniqueNoList.map((item) => {
                    const isSelected = this.state.modalSelectedUniqueNos.some(
                        selected => selected.key === item.key
                    );
                    
                    return (
                        <div
                            key={item.key}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '12px 16px',
                                borderBottom: '1px solid #E5E7EB',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                backgroundColor: isSelected ? '#EBF5FF' : 'transparent'
                            }}
                            onClick={() => this.toggleUniqueNoSelection(item)}
                            onMouseEnter={(e) => {
                                if (!isSelected) {
                                    e.currentTarget.style.backgroundColor = '#F3F4F6';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isSelected) {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                }
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => this.toggleUniqueNoSelection(item)}
                                style={{
                                    marginRight: '12px',
                                    width: '18px',
                                    height: '18px',
                                    cursor: 'pointer'
                                }}
                                onClick={(e) => e.stopPropagation()}
                            />
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: '16px', fontWeight: '500', color: '#111827' }}>
                                    {item.UniqueNo1}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {this.state.uniqueNoList.length === 0 && (
                <div style={{ textAlign: 'center', padding: '40px', color: '#6B7280' }}>
                    No unique numbers available
                </div>
            )}
        </div>
    </Window>
)}

            </>
        );
    }
}

export default AddTicket;